import {
  SSO_CONFIGURATION_ERRORS,
  SUPPORTED_IDENTITY_PROVIDERS,
} from "./constants";

const isValidHttpUrl = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed || /\s/.test(trimmed)) return false;

  if (!trimmed.startsWith("http://") && !trimmed.startsWith("https://")) {
    return false;
  }

  try {
    const url = new URL(trimmed);
    return (
      (url.protocol === "http:" || url.protocol === "https:") && !!url.hostname
    );
  } catch {
    return false;
  }
};

const isValidCertificate = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed) return false;

  const startHeader = "-----BEGIN CERTIFICATE-----";
  const endHeader = "-----END CERTIFICATE-----";

  if (!trimmed.startsWith(startHeader) || !trimmed.endsWith(endHeader)) {
    return false;
  }

  // Extract content between headers and validate base64
  const content = trimmed
    .replace(startHeader, "")
    .replace(endHeader, "")
    .replace(/\s/g, "");

  const base64Regex = /^[A-Za-z0-9+/=]+$/;
  if (!base64Regex.test(content)) {
    return false;
  }

  try {
    atob(content);
    return true;
  } catch {
    return false;
  }
};

// Simple SSO config validation, no yup
export const SSO_CONFIGURATION_VALIDATION_SCHEMA = (
  values: Record<string, string>,
) => {
  const errors: Record<string, string> = {};

  if (!values.idpClient) errors.idpClient = SSO_CONFIGURATION_ERRORS.IDP_CLIENT; // idpClient required
  if (!values.certificate)
    errors.certificate = SSO_CONFIGURATION_ERRORS.CERTIFICATE; // certificate required
  if (!values.issuerUrl) errors.issuerUrl = SSO_CONFIGURATION_ERRORS.ISSUER_URL; // issuerUrl required
  if (!values.samlEndpoint)
    errors.samlEndpoint = SSO_CONFIGURATION_ERRORS.SAML_ENDPOINT; // samlEndpoint required
  if (!values.sloEndpoint)
    errors.sloEndpoint = SSO_CONFIGURATION_ERRORS.SLO_ENDPOINT; // sloEndpoint required

  if (
    values.idpClient &&
    !SUPPORTED_IDENTITY_PROVIDERS.includes(values.idpClient)
  )
    errors.idpClient = SSO_CONFIGURATION_ERRORS.IDP_CLIENT_INVALID;
  if (values.issuerUrl && !isValidHttpUrl(values.issuerUrl))
    errors.issuerUrl = SSO_CONFIGURATION_ERRORS.ISSUER_URL_INVALID;
  if (values.samlEndpoint && !isValidHttpUrl(values.samlEndpoint))
    errors.samlEndpoint = SSO_CONFIGURATION_ERRORS.SAML_ENDPOINT_INVALID;
  if (values.sloEndpoint && !isValidHttpUrl(values.sloEndpoint))
    errors.sloEndpoint = SSO_CONFIGURATION_ERRORS.SLO_ENDPOINT_INVALID;
  if (values.certificate && !isValidCertificate(values.certificate))
    errors.certificate = SSO_CONFIGURATION_ERRORS.CERTIFICATE_INVALID;

  return errors;
};
